import { BLUE_300, BLUE_500, BLACK_100, BLACK_500, BLACK_700, BLACK_900, BLUE_GREY_200, BLUE_GREY_300, BLUE_GREY_400, GRADIENT_PURPLIN_END, GREEN_200, GREEN_400, LILAC_500, LILAC_900, RED_200, RED_400, WHITE, YELLOW_200, YELLOW_400 } from '../../constants/colors';
var infoTagConfig = {
  theme: 'light',
  type: 'inline',
  subType: 'default',
  size: 'md',
  transformToUppercase: false,
  text: '',
  iconPosition: 'left',
  iconName: '',
  config: {
    size: {
      sm: {
        'on-card': {
          height: 16,
          paddingHorizontal: 'SPACING_4',
          iconSize: 12
        },
        inline: {
          height: 16,
          paddingHorizontal: 'SPACING_4',
          iconSize: 12
        }
      },
      md: {
        'on-card': {
          height: 20,
          paddingHorizontal: 'SPACING_4',
          iconSize: 16
        },
        inline: {
          height: 20,
          paddingHorizontal: 'SPACING_4',
          iconSize: 16
        }
      },
      lg: {
        'on-card': {
          height: 24,
          paddingHorizontal: 'SPACING_4',
          iconSize: 20
        },
        inline: {
          height: 24,
          paddingHorizontal: 'SPACING_4',
          iconSize: 20
        }
      }
    },
    subType: {
      new: {
        color: BLACK_100,
        bgColor: BLUE_500,
        borderColor: BLUE_300
      },
      default: {
        color: BLACK_900,
        bgColor: LILAC_500,
        borderColor: LILAC_900
      },
      warning: {
        color: BLACK_900,
        bgColor: YELLOW_200,
        borderColor: YELLOW_400
      },
      success: {
        color: BLACK_900,
        bgColor: GREEN_200,
        borderColor: GREEN_400
      },
      offer: {
        gradientType: 'RETRO',
        color: BLACK_100,
        borderColor: GRADIENT_PURPLIN_END
      },
      error: {
        color: BLACK_900,
        bgColor: RED_200,
        borderColor: RED_400
      },
      disabled: {
        color: BLACK_700,
        bgColor: BLACK_500,
        borderColor: BLACK_500
      }
    }
  }
};
var infoTagWhiteConfig = Object.assign(Object.assign({}, infoTagConfig), {
  theme: 'white',
  config: Object.assign(Object.assign({}, infoTagConfig.config), {
    subType: Object.assign(Object.assign({}, infoTagConfig.config.subType), {
      new: {
        color: WHITE,
        bgColor: BLUE_500,
        borderColor: BLUE_300
      },
      default: {
        color: BLACK_900,
        bgColor: BLUE_GREY_200,
        borderColor: BLUE_GREY_400
      },
      warning: {
        color: BLACK_900,
        bgColor: YELLOW_200,
        borderColor: YELLOW_400
      },
      success: {
        color: BLACK_900,
        bgColor: GREEN_200,
        borderColor: GREEN_400
      },
      error: {
        color: BLACK_900,
        bgColor: RED_200,
        borderColor: RED_400
      },
      disabled: {
        color: BLUE_GREY_400,
        bgColor: BLUE_GREY_200,
        borderColor: BLUE_GREY_300
      }
    })
  })
});
export default {
  light: infoTagConfig,
  dark: infoTagConfig,
  white: infoTagWhiteConfig
};